import Component from './productionViewConfigurator.vue';

export default {
  install(Vue) {
    Vue.component('BkfProdviewconfiguratorDialog', Component);
  },
};
